import React from "react";
import { Route, Switch } from "react-router-dom";
import { groupRoutes } from "./routes";
import GroupPageLayout from "./GroupRouteWrapper";

const GroupRouter = () => {
  return (
    <GroupPageLayout>
      <Switch>
        {groupRoutes.map((route, index) => (
          <Route key={index} exact={route.exact} path={route.path}>
            <route.component />
          </Route>
        ))}
      </Switch>
    </GroupPageLayout>
  );
};

export default GroupRouter;
